import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

import { isDev } from '@utils/env';

/**
 * Dynamic import id (string) doesn't recognize isDev(),
 * so we cannot do require(isDev() ? 'a' : 'b')
 * we need to do require('a') or require('b')
 */
const firebaseConfig = isDev() ? require('./dev.json') : require('./prod.json');

const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

export { firebaseApp };
